import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Team schedule (HaloPSA dispatch / Outlook calendar). Owned by the schedule module.
export const routes: RouteObject[] = [{ path: 'schedule', lazy: page(() => import('./schedule-page'), (m) => m.SchedulePage) }];
export const orgRoutes: RouteObject[] = [];
